import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import PageSeo from "../../common/PageSeo/PageSeo";
import FloatingEnquiry from "../../common/FloatingEnquiry/FloatingEnquiry";
import { RecruitmentModalProvider } from "../../common/RecruitmentModal/RecruitmentModal";

function MainLayout({ children, noTopPadding = false }) {
  return (
    <RecruitmentModalProvider>
      <PageSeo />
      <Navbar />

      <main className="pt-[88px]">
        {children}
      </main>

      <FloatingEnquiry />

      <Footer />
    </RecruitmentModalProvider>
  );
}

export default MainLayout;
